import { useForgotPassword } from "hooks/useForgotPassword";

export default function useForgotPasswordPage () {

  const {isLoading: isResettingPassword, data: resetPasswordData, mutate: resetPassword, isSuccess: hasResetPassword, isError: failedResettingPassword} = useForgotPassword();

  return {
    isResettingPassword,
    resetPassword,
    resetPasswordData,
    hasResetPassword,
    failedResettingPassword,
  }

}